var _a;
import TransactionCompanyWrapper from "./TransactionCompanyWrapper";
class TransactionMeta {
    company;
    regions;
    sector;
    types;
    constructor(response) {
        this.company = response.company !== undefined ? new TransactionCompanyWrapper(response.company) : undefined;
        this.regions = response.regions;
        this.sector = response.sector;
        this.types = response.types;
    }
    #clone() {
        return new _a(this.toReponse());
    }
    checkEmpty() {
        return this.company?.type === undefined || this.company.companyId === undefined || this.sector === undefined || this.regions === undefined || this.regions.length === 0 || this.types === undefined || this.types.length === 0;
    }
    toReponse() {
        return {
            company: this.company !== undefined ? this.company.toResponse() : undefined,
            regions: this.regions,
            sector: this.sector,
            types: this.types
        };
    }
    updateCompany(company) {
        const clone = this.#clone();
        clone.company = company;
        return clone;
    }
    transactionCompanyOnly() {
        const clone = this.#clone();
        clone.company = this.company?.transactionCompanyOnly();
        return clone;
    }
    updateCompanyType(type) {
        const clone = this.#clone();
        clone.company ??= new TransactionCompanyWrapper({});
        clone.company.type = type;
        return clone;
    }
    updateSector(sector) {
        const clone = this.#clone();
        clone.sector = sector;
        return clone;
    }
    updateRegion(regions) {
        const clone = this.#clone();
        clone.regions = regions;
        return clone;
    }
    updateType(types) {
        const clone = this.#clone();
        clone.types = types;
        return clone;
    }
    #addCompanyRole() {
        if (this.company !== undefined && this.company.type === undefined) {
            if (this.types !== undefined) {
                if (this.types.includes('NEW_ISSUE')) {
                    this.company.type = 'ISSUER';
                }
                else if (this.types.includes('TENDER_OFFER')) {
                    this.company.type = 'OFFEROR';
                }
                else if (this.types.includes('INVESTOR_UPDATE') || this.types.includes('NON_DEAL_ROADSHOW')) {
                    this.company.type = 'COMPANY';
                }
                else {
                    this.company.type = 'ISSUER';
                }
            }
            else {
                this.company.type = 'ISSUER';
            }
        }
    }
    merge(that) {
        const clone = this.#clone();
        clone.company = that.company !== undefined ? new TransactionCompanyWrapper(that.company) : undefined;
        if (that.regions !== undefined) {
            clone.regions = [...new Set(that.regions.concat(clone.regions ?? []))];
        }
        clone.sector = this.sector ?? that.sector;
        clone.#addCompanyRole();
        return clone;
    }
    update(type, value) {
        const clone = this.#clone();
        switch (type) {
            case 'SECTOR':
                clone.sector = value;
                break;
            case 'REGION':
                clone.regions = value;
                break;
            case 'TYPES':
                clone.types = value;
                break;
            case 'COMPANY_TYPE':
                {
                    clone.company ??= new TransactionCompanyWrapper({});
                    clone.company.type = value;
                }
                break;
            default:
        }
        return clone;
    }
}
_a = TransactionMeta;
export default TransactionMeta;
